import React from 'react';

import { CategoryHighlightBlockData } from 'api/cms';
import { AmpCardsBlock } from 'cms/blocks/Amp/AmpCardsBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';
import { Box } from 'components/Box';

export function AmpCategoryHighlightBlock({
  blockId,
  content,
  data,
}: AmpBlockMappingComponentProps<CategoryHighlightBlockData>) {
  return (
    <AmpCardsBlock
      blockId={blockId}
      content={content}
      data={{
        ...data,
        headline: data.headline,
        cards: data.categories.map((category) => ({
          headline: category.name,
          image: category.image,
          text: category.description,
          body: (
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {category.pages
                ? category.pages.map((page) => (
                    <Box
                      component="a"
                      href={page.url}
                      key={page.id}
                      display="block"
                    >
                      {page.title}
                    </Box>
                  ))
                : null}
            </>
          ),
        })),
      }}
    />
  );
}
